import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { CompanyModel } from '@models/CompanyModel';

import { GenericSmartList, SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
import { CustomerModel } from '@models/CustomerModel';
import { TransactionAccumulateModel } from '@models/TransactionModel';
import { ApiTransactionService } from '@services/api-transaction.service';
import { SharedService } from '@services/shared.service';
import { Router } from '@angular/router';



@Component({
    selector: 'app-smart-list-user-point',
    templateUrl: './smart-list-user-point.component.html',
    styleUrls: ['./smart-list-user-point.component.scss']
})
export class SmartListUserPointComponent extends GenericSmartList<SmartListTransactionItem> implements OnInit, OnChanges {

    @Input() points: SmartListTransactionItem[] = [];

    @Input() user: CustomerModel;

    @Output() updatePoints = new EventEmitter<void>();

    lastId: number;


    constructor(public apiTransactionService: ApiTransactionService,
        public sharedService: SharedService,
        public router: Router,
        private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {

        this.source = this.points;

        
    }

    ngOnChanges(changes: SimpleChanges): void {

        for (const propName in changes) {
            if (propName === 'points') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    this.source = this.points; 
                    this._reAssignPoints();
                    this.cdr.detectChanges();
                }
            }
        }
    }

    getPageMonth(current: number) {

        return [
            'ENE', 'FEB', 'MAR', 'ABR',
            'MAY', 'JUN', 'JUL', 'AGO',
            'SEP', 'OCT', 'NOV', 'DIC',
        ][current - 1];
    }

    onCalculateDateDifference(created, subtractDate): number {
        const date1Obj = new Date(created);
        const date2Obj = new Date(subtractDate);
    
        const timeDifference = date2Obj.getTime() - date1Obj.getTime();
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    
        return daysDifference;
    }

    onCurrentId(id: number){

        if(this.lastId){
            if(id === this.lastId){
                this.lastId = id;
                return false;
            }else{
                this.lastId = id;
                return true;
            }
        }else{
            this.lastId = id;
            return true;
        }

    }

    onViewPointsDetails(transactionId: number){

        this.router.navigate(['/accumulateCupon', transactionId, 0]);
    
    }

    private _reAssignPoints(){

        //reAssign the point if the bit has been created 15 day ago
        this.source.forEach((transaction) => {
            if (
                transaction.customerOwnerId === this.user?.id &&
                transaction.orderStatus === 1 &&
                (transaction.type === 41 || transaction.type === 141 || transaction.type === 241) &&
                transaction.createdAt
            ) {
                //get the created date and make the division to calculate if it was created 15 days ago
                const daysDifference = this.onCalculateDateDifference(transaction.createdAt, new Date());
    
                if (daysDifference >= 15) {
                    
                    //acumulate points
                    this._accumulateCoupon(transaction.coupons[0].transactionId);
                }
            }
        });
    }

    private _accumulateCoupon(transactionId){
    
        this.sharedService.setLoading(true);

        let accumulateCoupon = new TransactionAccumulateModel({

            transactionId: transactionId,
            vendorUserId: null,
            shippingProviderId: null,
            isSuccessful: null,
            messageResult: null
        });
        
        this.apiTransactionService.accumulateCoupon(accumulateCoupon).then(()=>{

            //refres user points
            this.updatePoints.emit();
            
            this.sharedService.setLoading(false);
        },
        (err) => {
            this.sharedService.setLoading(false);
        });
    }
}
